import styled from 'styled-components'
import grabColor from 'src/utils/grabColor'

const SelectBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ selected }) => (selected ? grabColor('action.DEFAULT') : 'white')};
  border: 2px solid
    ${({ selected }) =>
      selected ? grabColor('action.secondary') : grabColor('borderInput')};
  border-radius: 2px;
  height: 100%;
  width: 100%;
  text-align: center;
  color: ${({ selected }) => (selected ? 'white' : grabColor('detail'))};
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  height: ${({ height }) => (height ? height : '56px')};
  width: ${({ width }) => (width ? width : '100%')};

  &:hover,
  &:focus {
    background: ${grabColor('action.secondary')};
    border-color: ${grabColor('action.tertiary')};
    color: white;
  }
`

export default SelectBtn
